<template>
  <div class="insure-form">
    <div class="title">确认申报地块和投保人信息</div>
    <div class="cell" style="margin-top: 28px">
      <span>计划种植作物和申报地块</span>
    </div>
    <div class="form-wrapper">
      <el-form
        label-width="132px"
        label-position="left"
        :model="firstModelInfo"
        ref="firstMoForm"
        :rules="firstRules"
        class="firstFormSty"
      >
        <el-form-item label="计划种植作物" prop="grainType">
          <el-select
            class="form-item"
            v-model="firstModelInfo.grainType"
            placeholder="请选择"
          >
            <el-option
              v-for="item in planPlantCrop"
              :key="item.value"
              :value="item.value"
              :label="item.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="每亩可保产量" prop="numPerUnit">
          <el-input
            class="form-item"
            v-model="firstModelInfo.numPerUnit"
            @input="amountClick()"
            placeholder="请输入1-1000的整数"
          ></el-input>
          <span style="display: inline-block; margin-left: 13px">斤</span>
          <div style="font-weight: 400; color: #cccccc">
            注：每亩最大可保产量为1000斤
          </div>
        </el-form-item>
        <el-form-item label="预计保费" prop="amountEstimate">
          <span style="font-weight: 400; font-size: 16px">{{
            firstModelInfo.amountEstimate
              ? firstModelInfo.amountEstimate + "元"
              : "--"
          }}</span>
          <div style="font-weight: 400; color: #cccccc">
            注：保费计算规则，保费=投保面积（亩）*每亩可保产量（斤/亩）*0.5元/斤
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="cell" @click="showForm = !showForm">
      <span>投保人信息</span>
      <span>
        <i class="text">{{ showForm ? "收起" : "展开" }}</i>
        <i class="el-icon-arrow-down icon" :class="{ active: showForm }"></i>
      </span>
    </div>
    <el-collapse-transition>
      <div class="form-wrapper" v-show="showForm">
        <form-box
          ref="ruralInfoForm"
          class="form-box"
          @openForm="showForm = true"
        ></form-box>
      </div>
    </el-collapse-transition>
    <div class="btns-groups">
      <el-button class="prev btn" @click="clickPrevStep">上一步</el-button>
      <el-button
        class="submit btn"
        type="primary"
        @click="submitForm()"
        :loading="btnLoading"
        >提交投保意向单</el-button
      >
    </div>
  </div>
</template>
<script>
import FormBox from "./Form";
import {
  ruralInsurance,
  getInsureInfoByFarmId,
} from "@/api/request/snkd.produce";
import { mapState, mapGetters } from "vuex";
export default {
  components: { FormBox },
  data() {
    var perAmonut = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入每亩可保数量"));
      } else {
        if (Number(value) < 1 || Number(value) > 1000) {
          callback(new Error("每亩可保数量只能输入1-1000内的整数"));
        }
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入1-1000的整数"));
        }
        callback();
      }
    };
    return {
      showForm: true,
      insureId: 2,
      planPlantCrop: [
        { text: "南粳46", value: 4 },
        { text: "太安1号", value: 6 },
        // { text: "南粳9108", value: 5 },
        // { text: "松香粳1018", value: 2 },
        // { text: "沪软1212", value: 1 },
        // { text: "银香38", value: 3 },
      ], //计划种植作物
      firstModelInfo: {
        grainType: "",
        numPerUnit: null, //每亩可保产量
        amountEstimate: "", //预计保费
      }, //计划种植作物和申报地块信息
      firstRules: {
        grainType: [
          {
            required: true,
            message: "请选择计划种植品种",
            trigger: "change",
          },
        ],
        amountEstimate: [
          { required: true, message: "预计保费不能为空", trigger: "blur" },
        ],
        numPerUnit: [{ required: true, validator: perAmonut, trigger: "blur" }],
      },
      btnLoading: false,
      firstValidFlag: null,
      insureInfoId: null,
    };
  },
  computed: {
    ...mapState({
      companyId: (state) => state.companyId,
      farmId: (state) => state.farmId,
      // insureId: (state) => state.insure.insureId,
    }),
    ...mapGetters({
      hadSelectedLandList: "ruralInsure/hadSelectedLandList",
    }),
    totalAcre() {
      return this.calcLandAcre(this.hadSelectedLandList);
    },
  },
  methods: {
    clickPrevStep() {
      this.$emit("prev-step", "VerifyList");
    },
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => total + cur.coLandVO.statisticsLandAcre, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    handleSelectCrop() {},
    async submitForm() {
      if (this.btnLoading) {
        return;
      }
      const validateRes = await this.$refs.ruralInfoForm.validateForm();
      this.$refs["firstMoForm"].validate(async (valid1) => {
        this.firstValidFlag = valid1;
      });
      // 校验用户信息表单
      if (validateRes && this.firstValidFlag) {
        this.btnLoading = true;
        const formInfo = { ...this.$refs.ruralInfoForm.form };
        if (
          formInfo.validDate == "" &&
          this.$refs.ruralInfoForm.longEffective
        ) {
          formInfo.validDate = "2099-01-01";
        }
        const info = await getInsureInfoByFarmId({
          companyId: this.companyId,
          farmId: this.farmId,
        });
        if (info.obj) {
          this.insureInfoId = info.obj.id ? info.obj.id : null;
        }
        formInfo.id = this.insureInfoId;
        const params = {
          coInsureGrainReq: this.firstModelInfo,
          coListInsureOrderLandRespList: this.hadSelectedLandList,
          companyId: this.companyId,
          farmId: this.farmId,
          farmInsureAddReq: formInfo,
          insureId: this.insureId,
        };
        ruralInsurance.addRuralInsureOrder(params).then((res) => {
          this.btnLoading = false;
          if (res.respCode == 300 || res.respCode == 404) {
            const respDesc = this.formatStr(res.respDesc, "$");
            const msgHtml = `失败原因：<br>${respDesc.split("$").join("<br>")}`;
            this.$alert(msgHtml, "投保失败", {
              confirmButtonText: "确定",
              dangerouslyUseHTMLString: true,
            });
          }
          if (res.respCode == 70002) {
            const msgHtml = `失败原因：<br>${res.respDesc
              .split(",")
              .join("<br>")}`;
            this.$alert(msgHtml, "投保失败", {
              confirmButtonText: "确定",
              dangerouslyUseHTMLString: true,
            });
          }
          if (res.respCode == 0) {
            this.$message({
              message:
                "您已提交安信优质稻米收入险投保意向，请耐心等待工作人员与您联系",
              type: "success",
            });
            setTimeout(() => {
              // 退出投保页面时，清空一些状态
              this.$store.commit("ruralInsure/clearInsurePageStatus");
              this.$router.push({
                name: "RuralList",
                params: {
                  id: res.obj.orderId,
                },
              });
            }, 2000);
          }
        });
      }
    },
    amountClick() {
      const amount = Number(this.firstModelInfo.numPerUnit);
      this.firstModelInfo.amountEstimate = parseFloat(
        (this.totalAcre * amount * 0.5).toFixed(2)
      );
    },
    formatStr(str, flag = "$") {
      let res = str;
      [";", "；"].forEach((s) => {
        res = res.replace(new RegExp(s, "g"), flag);
      });
      return res;
    },
  },
};
</script>
<style lang="scss" scoped>
.firstFormSty {
  // width: 620px;
  padding-left: 195px;
}
.form-item {
  width: 240px;
}
.insure-form {
  background: #ffffff;
  padding: 0 100px 158px;
  .title {
    font-weight: 600;
    font-size: 22px;
    color: #333333;
    padding: 40px 0;
    text-align: center;
  }
  .cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    height: 60px;
    background: #f7f9fb;
    color: $--color-primary;
    font-size: 18px;
    padding: 0 23px 0 16px;
    cursor: pointer;
    i.icon {
      font-weight: bold;
      transition: all 0.5s;
      &.active {
        transform: rotate(-180deg);
      }
    }
    i.text {
      transition: all 0.5s;
      font-size: 16px;
      margin-right: 10px;
    }
  }
  .form-wrapper {
    display: flex;
    justify-content: center;
    padding: 36px 0 33px;
    .form-box {
      // width: 372px;
      width: 400px;
    }
  }
  .pay-method {
    display: flex;
    margin-top: 30px;
    padding-left: 310px;
    .title {
      font-size: 16px;
      color: #333333;
    }
    .online {
      display: inline-flex;
      align-items: center;
      img {
        width: 332px;
        height: 80px;
        margin-left: 39px;
        cursor: default;
      }
    }
    ::v-deep .el-form-item {
      display: flex;
      .el-form-item__label {
        box-sizing: border-box;
        padding-top: 20px;
        margin-right: 55px;
      }
    }
  }
  .tips {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #ff831e;
    text-align: center;
    margin-top: 20px;
  }
  .btns-groups {
    margin-top: 48px;
    text-align: center;
    .prev {
      width: 122px;
      margin-right: 14px;
      color: $--color-primary;
      border-color: $--color-primary;
    }
    .submit {
      width: 150px;
    }
  }
}
</style>
